import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import footerData from '../data/footerData.json';
import './Footer.css';

const Footer = () => {
  const location = useLocation();

  const handleLogoClick = (e) => {
    // If already on home page, scroll to top instead of navigating
    if (location.pathname === '/') {
      e.preventDefault();
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
    // Otherwise, let the Link component handle navigation normally
  };

  return (
    <footer className="bg_dark dark_bg footer">
      <figure className="bg_img cover">
      <img src={'/assets/images/footer_bg.png'} alt="" />
      </figure>
      <div className="container top">
        <div className="left">
          <Link to="/" className="logo icon" onClick={handleLogoClick}>
            <img src={footerData.logo} alt="Peck Dating" />
          </Link>
          {/* <span>{footerData.communityText}</span> */}
          <ul className="social_listing mt">
          <li>
              <a
                className="small text_white icon"
                href={footerData.appStoreLink}
                target="_blank"
                rel="noopener noreferrer"
              >
                <figure>
                  <img src={footerData.appStoreIcon} alt="App Store" />
                </figure>
              </a>
            </li>
            <li>
              <a
                className="small text_white icon"
                href={footerData.playStoreLink}
                target="_blank"
                rel="noopener noreferrer"
              >
                <figure>
                  <img src={footerData.playStoreIcon} alt="Play Store" />
                </figure>
              </a>
            </li>
            
          </ul>
        </div>
        <div className="right">
          <div>
            <h3>Legal</h3>
            <ul>
              {/* Corrected: (item, index) and added implicit return with parentheses */}
              {footerData?.footerLinks?.privacy?.map((link, index) => (
                <li key={index}>
                  <Link to={link.url} className="small">
                    {link.text}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h3>Safety & Community</h3>
            <ul>
              {/* Corrected: (item, index) and added implicit return with parentheses */}
              {footerData?.footerLinks?.safety?.map((link, index) => (
                <li key={index}>
                  <Link to={link.url} className="small">
                    {link.text}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <div className="bottom text-center">
        <div className="container">
          <ul className="social_icons">
            {footerData.socialLinks.map((social, index) => (
              <li key={index}>
                <a href={social.url} target="_blank" rel="noopener noreferrer" aria-label={social.name}>
                  <img src={social.icon} alt={social.name} />
                </a>
              </li>
            ))}
          </ul>
          <span className="copyright d-block small">{footerData.copyright}<br></br></span>
        </div>
      </div>


    </footer>
  );
};

export default Footer;
